import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { GetUserDetailApi } from '../redux/actions/teams/members/GetUserDetailsActions';
import { UpdateUser } from "../redux/actions/teams/members/UpdateUserAction";
import { PulseLoader } from "react-spinners";
import { Eye, EyeOff } from "lucide-react";

const EditUser = () => {
  const { id } = useParams(); 
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Pulling Redux state like your QuizDetails example
  const {
    response: userDetails,
    loading: userLoading,
    error: userError,
  }  = useSelector(
      (state) => state.UsersDetails
    );
  const {
    loading: updateLoading,
    error: updateError,
    response: updateSuccess,
  } = useSelector((state) => state.updateUser);

  const [showPassword, setShowPassword] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [verified, setVerified] = useState(false);
  const [errors, setErrors] = useState({});

  // Populate form fields when userDetails changes
useEffect(() => {
  if (userDetails?.data) {
    const nameParts = (userDetails.data.name || "").split(" ");
    setFirstName(nameParts[0] || "");
    setLastName(nameParts.slice(1).join(" ") || "");
    setEmail(userDetails.data.email || "");
    const due = userDetails.data.due_date;
    setDueDate(due ? due.split("T")[0] : "");
  }
}, [userDetails]);


  // Fetch user details on mount
  useEffect(() => {
    dispatch(GetUserDetailApi(id));
  }, [dispatch, id]);

  const validateForm = () => {
    let newErrors = {};
    let valid = true;

    if (!firstName.trim()) {
      newErrors.firstName = "First name is required";
      valid = false;
    }
    if (!lastName.trim()) {
      newErrors.lastName = "Last name is required";
      valid = false;
    }
    if (!email.trim()) {
      newErrors.email = "Email is required";
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Enter a valid email";
      valid = false;
    }
    if (password && password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

 const handleSubmit = (e) => {
  e.preventDefault();
  if (!validateForm()) return;

  const userData = {
    name: `${firstName} ${lastName}`,
    email,
    due_date: dueDate || null,
  };

  dispatch(UpdateUser(id, userData))
    .then(() => {
        navigate("/dashboard/user-management");
    })
    .catch((err) => {
      console.error("Failed to update user:", err);
    });
};


  return (
    <div className="content-wrapper" style={{ backgroundColor: "#f5f5f5" }}>
      <section className="main-section">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8">
              <form onSubmit={handleSubmit} className="p-4 shadow rounded bg-white">
                <h3 className="text-center mb-4">Edit User</h3>

                {(userLoading || updateLoading) && (
                  <div className="text-center mb-3">
                    <PulseLoader color="#36d7b7" size={10} />
                  </div>
                )}

                {userError && <div className="alert alert-danger">{userError}</div>}
                {updateError && <div className="alert alert-danger">{updateError}</div>}

                <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={firstName}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Uppercase first letter, keep the rest as typed
                      const formatted = value.charAt(0).toUpperCase() + value.slice(1);
                      setFirstName(formatted);
                    }}
                  />
                  {errors.firstName && (
                    <small className="text-danger">{errors.firstName}</small>
                  )}
                </div>

                  <div className="col-md-6">
                    <label className="form-label">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={lastName}
                      onChange={(e) => {
                      const value = e.target.value;
                      // Uppercase first letter, keep the rest as typed
                      const formatted = value.charAt(0).toUpperCase() + value.slice(1);
                      setLastName(formatted);
                    }}
                      // onChange={(e) => setLastName(e.target.value)}
                    />
                    {errors.lastName && (
                      <small className="text-danger">{errors.lastName}</small>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>

                  {/* <div className="col-md-6 position-relative">
                    <label className="form-label">Password</label>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter new password (optional)"
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        top: "38px",
                        right: "10px",
                        cursor: "pointer",
                      }}
                    >
                      {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                    </span>
                    {errors.password && (
                      <small className="text-danger">{errors.password}</small>
                    )}
                  </div> */}

                  <div className="col-md-6">
                    <label className="form-label">Due Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dueDate}
                      onChange={(e) => setDueDate(e.target.value)}
                    />
                  </div>

                  {/* <div className="col-md-6 d-flex align-items-center">
                    <div>
                      <label className="form-label me-2">Verified</label>
                      <input
                        type="checkbox"
                        checked={verified}
                        onChange={(e) => setVerified(e.target.checked)}
                      />
                    </div>
                  </div> */}
                </div>

                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-success px-4"
                    disabled={userLoading || updateLoading}
                  >
                    {updateLoading ? "Changing..." : "Save Changes"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditUser;
